import React from 'react';
import PropTypes from 'prop-types';
import { BarLoader } from 'react-spinners';
import Video from './Video';
import Document from './Document';
import Tip from './Tip';
import ResourcesAccordion from './ResourcesAccordion';

class Resources extends React.Component {
  constructor(props) {
    super(props);

    this.hasResources = this.props.resources.map(resource => {
      if (resource.associations.includes(this.props.sector || this.props.product)) {
        return true;
      }
      return false;
    });
  }

  componentDidMount() {
    const tmp = this;
    setTimeout(() => {
      tmp.loadData();
    }, 2250);
  }

  loadData() {
    this.hasResources = this.props.resources.map(resource => {
      if (resource.associations.includes(this.props.sector || this.props.product)) {
        return true;
      }
      return false;
    });

    this.setState({
      hasResource: this.hasResources,
    });
  }

  render() {
    const {
      resources,
      isResourcesAccordionOpen,
      toggleResourcesAccordion,
      isFilterOpen,
    } = this.props;
    const ln = resources.length;
    const hasResources = this.hasResources;

    if (resources === undefined) {
      return (
        <div className="spinner-holder">
          <BarLoader color={'#150F96'} />
        </div>
      );
    }
    if (hasResources.includes(true)) {
      return (
        <ResourcesAccordion
          isResourcesAccordionOpen={isResourcesAccordionOpen}
          toggleResourcesAccordion={toggleResourcesAccordion}
        >
          <section className="appetite">
            <div className="accordion__content-wrapper container">
              <h2 className="appetite__heading appetite__heading--resources">Resources</h2>
              <button
                className={`accordion__trigger ${isFilterOpen ? 'is-disabled' : ''}`}
                onClick={toggleResourcesAccordion}
              >
                <i
                  className={`${
                    isResourcesAccordionOpen ? 'fal fa-minus' : 'fal fa-plus'
                  }`}
                />
              </button>
            </div>
            <div
              className={`accordion__content-wrapper resources-bg resources-bg--acc accordion ${
                isResourcesAccordionOpen ? 'accordion__open' : ''
              }`}
            >
              <div className="container container--resources">
                {ln > 0 ? (
                  resources
                    .sort((a, b) => {
                        let initial = a.title.toLowerCase(),
                            next = b.title.toLowerCase();
                        if (initial < next) return -1;
                        if (initial > next) return 1;
                        return 0;
                    })
                    .map((video, i) => <Video {...this.props} resource={video} i={i} key={i} />)
                    .filter(
                      video =>
                        video.props.resource.type === 'video' ||
                        video.props.resource.type === 'Video'
                    )
                    .filter(video =>
                      video.props.resource.associations.includes(
                        video.props.product || video.props.sector
                      )
                    )
                ) : (
                  <div className="spinner-holder">
                    <BarLoader color={'#150F96'} />
                  </div>
                )}
              </div>
              <div className="container container--resources ie-clearfix">
                {ln > 0 ? (
                  resources
                    .sort((a, b) => {
                                                let initial = a.title.toLowerCase(),
                                                    next = b.title.toLowerCase();
                                                if (initial < next) return -1;
                                                if (initial > next) return 1;
                                                return 0;
                                            })
                    .map((doc, i) => <Document {...this.props} resource={doc} i={i} key={i} />)
                    .filter(
                      doc =>
                        doc.props.resource.type === 'PDF' ||
                        doc.props.resource.type === 'pdf' ||
                        doc.props.resource.type === 'link' ||
                        doc.props.resource.type === 'Link'
                    )
                    .filter(doc =>
                      doc.props.resource.associations.includes(
                        doc.props.product || doc.props.sector
                      )
                    )
                ) : (
                  <div className="spinner-holder">
                    <BarLoader color={'#150F96'} />
                  </div>
                )}
                {ln > 0 ? (
                  resources
                    .sort((a, b) => {
                                                let initial = a.title.toLowerCase(),
                                                    next = b.title.toLowerCase();
                                                if (initial < next) return -1;
                                                if (initial > next) return 1;
                                                return 0;
                                            })
                    .map((tip, i) => <Tip {...this.props} resource={tip} i={i} key={i} />)
                    .filter(tip => tip.props.resource.type === 'tip')
                    .filter(tip =>
                      tip.props.resource.associations.includes(
                        tip.props.product || tip.props.sector
                      )
                    )
                ) : (
                  <div className="spinner-holder">
                    <BarLoader color={'#150F96'} />
                  </div>
                )}
              </div>
            </div>
          </section>
        </ResourcesAccordion>
      );
    }
    return null;
  }
}

export default Resources;



// WEBPACK FOOTER //
// ./src/components/Resources.js